import withLoading from '../../core/common/withLoading';

export const StudentLoginPage = withLoading(() => import('./StudentLoginPage'));
export const TeacherLoginPage = withLoading(() => import('./TeacherLoginPage'));
export const ResetPassword = withLoading(() => import('./ResetPassword'));
export const CreateAccount = withLoading(() => import('./CreateAccount'));
export const CompleteAccount = withLoading(() => import('./CompleteAccount'));
export const UpdatePassword = withLoading(() => import('./UpdatePassword'));



// WEBPACK FOOTER //
// ./src/app/ui/pages/login/index.js